import script from "./AppGitDeployment.vue?vue&type=script&setup=true&lang=js"
export * from "./AppGitDeployment.vue?vue&type=script&setup=true&lang=js"

import "./AppGitDeployment.vue?vue&type=style&index=0&id=ffd19f8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffd19f8c"]])

export default __exports__